import React, { useState } from 'react';
import { Divider } from 'antd';
import FundedView from 'components/Status/fundedView';
import SEView from 'components/Status/seView';
import PCEView from 'components/Status/pceView';
import IpsWorkCompleteSection from '../IpsWorkCompleteSection/IpsWorkCompleteSection';
import CheckListView from './ipsChecklistView';

import ControlCircuitsView from 'components/Status/controlCircuitsView';
import './projectChecklist.css';
import trashcan from "../../../../assets/TasksImages/trashcan.png";
import ConfirmationDialog from "../../../../components/ConfirmationDialog";
import {confirmAlert} from "react-confirm-alert";

function IPSProjectChecklist(props) {
  const {
    project,
    allComments,
    handleProjectDetailUpdate,
    context,
    history,
    isReadOnly,
    allDropDownOptions,
    phaseDetails,
    phaseId,
    isItLastPhase
  } = props;

  const [SEComments, setSEComments] = useState(
    allComments.filter((everyComment) => everyComment.commentGrp === 'SE')
  );
  const [PCEComments, setPCEComments] = useState(
    allComments.filter((everyComment) => everyComment.commentGrp === 'PCE')
  );
  const [FundedComments, setFundedComments] = useState(
    allComments.filter((everyComment) => everyComment.commentGrp === 'FUNDED')
  );

  const [controlCircuitsComments, setControlCircuits] = useState(
    allComments.filter((everyComment) => everyComment.commentGrp === 'CTRL')
  );
  
  const isProjectOnHold = project?.projectHoldFlag === 'Y';

  return (
    <>
      <div className='border-container'>
        <CheckListView
          project={project}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
        />

        <Divider className='border-above' />
        <FundedView
          project={project}
          comments={FundedComments}
          locDropDownOptions={allDropDownOptions?.locStatus}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
          isProjectOnHold={isProjectOnHold}
        />
        <Divider className='border-above' />
        <SEView
          project={project}
          comments={SEComments}
          SEDropDownOptions={allDropDownOptions?.seStatus}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
          isProjectOnHold={isProjectOnHold}
        />
        <Divider className='border-above' />
        <PCEView
          project={project}
          comments={PCEComments}
          PCEDropDownOptions={allDropDownOptions?.pceStatus}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
          isProjectOnHold={isProjectOnHold}
        />
        <Divider className='border-above' />

        <ControlCircuitsView
          project={project}
          comments={controlCircuitsComments}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
          isProjectOnHold={isProjectOnHold}

        />
        <Divider className='border-above' />
        <IpsWorkCompleteSection
          project={project}
          history={history}
          context={context}
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          isReadOnly={isReadOnly}
          phaseDetails={phaseDetails}
          phaseId={phaseId}
          isProjectOnHold={isProjectOnHold}
          isItLastPhase={isItLastPhase}
        />
      </div>
    </>
  );
}

export default IPSProjectChecklist;
